import _implicitStylesheets from "./attachFiles.css";

import _implicitScopedStylesheets from "./attachFiles.scoped.css?scoped=true";

import _lightningButton from "lightning/button";
import {registerTemplate, sanitizeAttribute} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, h: api_element, t: api_text, k: api_key, d: api_dynamic_text, i: api_iterator, gid: api_scoped_id} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7} = $ctx;
  return [api_element("div", {
    key: 0
  }, [api_element("span", {
    key: 1
  }, [api_custom_element("lightning-button", _lightningButton, {
    classMap: {
      "slds-m-left_x-small": true
    },
    props: {
      "label": $cmp.viewAttachmentButtonLabel
    },
    key: 2,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleViewAttachments))
    }
  }, [])])]), api_element("div", {
    classMap: {
      "attachedFilesPanel": true
    },
    key: 3
  }, [api_element("div", {
    classMap: {
      "attachedFilesPanelHeader": true
    },
    key: 4
  }, [api_element("div", {
    classMap: {
      "selectDocTypeDiv": true
    },
    key: 5
  }, [api_element("label", {
    key: 6
  }, [api_text("1 - Select document type")]), api_element("select", {
    classMap: {
      "slds-select": true,
      "docType": true
    },
    key: 7
  }, api_iterator($cmp.docTypes, function (docType) {
    return api_element("option", {
      attrs: {
        "value": docType.value
      },
      key: api_key(8, docType.value)
    }, [api_text(api_dynamic_text(docType.label))]);
  }))]), api_element("div", {
    classMap: {
      "selectDocSourceDiv": true
    },
    key: 9
  }, [api_element("label", {
    key: 10
  }, [api_text("2 - Select document source")]), api_element("select", {
    classMap: {
      "slds-select": true,
      "docSource": true
    },
    key: 11,
    on: {
      "change": _m1 || ($ctx._m1 = api_bind($cmp.handleDocSourceChange))
    }
  }, api_iterator($cmp.docSources, function (docSource) {
    return api_element("option", {
      attrs: {
        "value": docSource.value
      },
      key: api_key(12, docSource.value)
    }, [api_text(api_dynamic_text(docSource.label))]);
  }))]), api_element("div", {
    classMap: {
      "fileInputPanels": true
    },
    key: 13
  }, [api_element("label", {
    key: 14
  }, [api_text("3 - Select the document for attaching")]), api_element("div", {
    classMap: {
      "fileInputPanel": true,
      "local-drive": true
    },
    key: 15
  }, [api_element("input", {
    classMap: {
      "slds-file-selector__input": true,
      "slds-assistive-text": true
    },
    attrs: {
      "id": api_scoped_id("attachFileinput"),
      "type": "file",
      "accept": $cmp.acceptedDocTypes,
      "aria-describedby": api_scoped_id("file-selector-id")
    },
    key: 16,
    on: {
      "change": _m2 || ($ctx._m2 = api_bind($cmp.handleFileChange))
    }
  }, []), api_element("label", {
    classMap: {
      "slds-file-selector__body": true
    },
    attrs: {
      "for": api_scoped_id("attachFileinput")
    },
    key: 17
  }, [api_element("span", {
    classMap: {
      "slds-file-selector__button": true,
      "slds-button": true,
      "slds-button--neutral": true
    },
    key: 18
  }, [api_element("span", {
    key: 19
  }, [api_element("svg", {
    classMap: {
      "slds-button__icon": true
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    },
    key: 20,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "resources/SLDS/icons/utility-sprite/svg/symbols.svg#open")
    },
    key: 21,
    svg: true
  }, [])])]), api_element("span", {
    classMap: {
      "slds-p-left_xx-small": true
    },
    key: 22
  }, [api_text("Browse")])]), api_element("span", {
    classMap: {
      "slds-file-selector__text": true
    },
    attrs: {
      "id": api_scoped_id("fileName")
    },
    key: 23
  }, [])]), api_element("span", {
    styleDecls: [["float", "right", false]],
    key: 24
  }, [api_custom_element("lightning-button", _lightningButton, {
    classMap: {
      "blue-utility-icon": true
    },
    props: {
      "label": "Use Camera",
      "iconName": "utility:photo",
      "title": "Take photo with device camera"
    },
    key: 25,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.handlePhotoShoot))
    }
  }, [])]), api_element("br", {
    key: 26
  }, []), api_custom_element("lightning-button", _lightningButton, {
    props: {
      "label": "Attach"
    },
    key: 27,
    on: {
      "click": _m4 || ($ctx._m4 = api_bind($cmp.addFileFromLocalDrive))
    }
  }, [])]), api_element("div", {
    classMap: {
      "fileInputPanel": true,
      "google-drive": true,
      "display-none": true
    },
    key: 28
  }, [!$cmp.isLoggedInToGoogle ? api_custom_element("lightning-button", _lightningButton, {
    props: {
      "label": "Sign in with Google"
    },
    key: 29,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.signInWithGoogle))
    }
  }, []) : null, $cmp.isLoggedInToGoogle ? api_custom_element("lightning-button", _lightningButton, {
    props: {
      "label": "Attach file from Google Drive"
    },
    key: 30,
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.addFileFromGoogleDrive))
    }
  }, []) : null, $cmp.isLoggedInToGoogle ? api_custom_element("lightning-button", _lightningButton, {
    props: {
      "label": "Revoke Google Drive Access"
    },
    key: 31,
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.callRevokeGoogleDriveAccess))
    }
  }, []) : null])])]), api_element("div", {
    classMap: {
      "attachedFilesPanelBody": true
    },
    key: 32
  }, [api_element("table", {
    context: {
      lwc: {
        dom: "manual"
      }
    },
    key: 33
  }, [])])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "zpaper-attachFiles_attachFiles"
